import styles from './TabContainer.module.scss';

interface TabContainerProps {
  children: React.ReactNode;
}

export default function TabContainer(props: TabContainerProps) {
  return <div className={styles.container}>{props.children}</div>;
}
